import queryString from 'query-string';
import { Endpoints } from 'UI/constants/endpoints';

import API from './API';
import { sendRequest } from './utils';

const getSendoutNotesEndpoint = (sendoutId, noteId) =>
  `${Endpoints.SendoutsNotes.replace(':id', sendoutId)}${noteId ? `/${noteId}` : ''}`;

export const createSendoutNote = async (sendoutId, data) =>
  API.post(getSendoutNotesEndpoint(sendoutId), data, { apiVersion: 2 });

export const updateSendoutNote = async (sendoutId, noteId, data) =>
  API.put(getSendoutNotesEndpoint(sendoutId, noteId), data, { apiVersion: 2 });

/**
 * @param {number} id
 * @param {string[]} scopes
 * @param {string[]} relations
 * @returns {Promise<OperationResult>}
 */
export const getSendoutById = async (id, scopes, relations) => {
  const params = {
    scopes: scopes || [],
    relations: relations || []
  };

  const queryParams = queryString.stringify(params, { arrayFormat: 'comma' });

  return sendRequest(`${Endpoints.Sendouts}/${id}?${queryParams}`, 'get');
};

/**
 * @param {number} id
 * @returns {Promise<OperationResult>}
 */
export const deleteSendoutById = async id => sendRequest(`${Endpoints.Sendouts}/${id}`, 'delete');

/**
 * @returns {Promise<OperationResult>}
 */
export const fetchDuplicates = async (params, options) => {
  const queryParams = queryString.stringify(params, { arrayFormat: 'comma' });
  return sendRequest(
    `${Endpoints.SendoutDuplicates}?${queryParams}`,
    'get',
    [],
    options?.successBody,
    options?.successTitle
  );
};
